<template>
  <div>
    <v-card class="ma-2" v-if="isVisible">
      <v-card-title  class="teal white--text">Status Registrasi Rekanan
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row class="text-center">
            <v-col cols="6" :class="statusColorText">{{ statusDataPerusahaan }} </v-col>
            <v-col cols="6" class="title font-weight-black">Tanggapan Divisi Pengadaan Perumda Pembangunan Sarana Jaya</v-col>
          </v-row>
          <v-divider />
          
          <v-row class="text-center my-4">
            <v-col cols="3" class='subtitle-1 font-weight-black'>Data Perusahaan</v-col>
            <v-col cols="3" :class='getColor(statusPerusahaan)'>{{ getCapDoc(statusPerusahaan) }}</v-col>
            <v-col> <span class="red--text">{{remarkPerusahaan}}</span> </v-col>
          </v-row>

          <v-row class="text-center my-4">
            <v-col cols="3" class='subtitle-1 font-weight-black'>Ijin Usaha</v-col>
            <v-col cols="3" :class='getColor(statusIjin)'>{{ getCapDoc(statusIjin) }}</v-col>
            <v-col> <span class="red--text">{{remarkIjin}}</span> </v-col>
          </v-row>

          <v-row class="text-center my-4">
            <v-col cols="3" class='subtitle-1 font-weight-black'>Akta Perusahaan</v-col>
            <v-col cols="3" :class='getColor(statusAkta)'>{{ getCapDoc(statusAkta) }}</v-col>
            <v-col> <span class="red--text">{{remarkAkta}}</span> </v-col>
          </v-row>

          <v-row class="text-center my-4">
            <v-col cols="3" class='subtitle-1 font-weight-black'>Data Pemilik</v-col>
            <v-col cols="3" :class='getColor(statusPemilik)'>{{ getCapDoc(statusPemilik) }}</v-col>
            <v-col> <span class="red--text">{{remarkPemilik}}</span> </v-col>
          </v-row>

          <v-row class="text-center my-4">
            <v-col cols="3" class='subtitle-1 font-weight-black'>Data Pengurus</v-col>
            <v-col cols="3" :class='getColor(statusPengurus)'>{{ getCapDoc(statusPengurus) }}</v-col>
            <v-col> <span class="red--text">{{remarkPengurus}}</span> </v-col>
          </v-row>

          <v-row class="text-center my-4">
            <v-col cols="3" class='subtitle-1 font-weight-black'>Pengalaman</v-col>
            <v-col cols="3" :class='getColor(statusPengalaman)'>{{ getCapDoc(statusPengalaman) }}</v-col>
            <v-col> <span class="red--text">{{remarkPengalaman}}</span> </v-col>
          </v-row>

          <v-row class="text-center my-4">
            <v-col cols="3" class='subtitle-1 font-weight-black'>Pajak</v-col>
            <v-col cols="3" :class='getColor(statusPajak)'>{{ getCapDoc(statusPajak) }}</v-col>
            <v-col> <span class="red--text">{{remarkPajak}}</span> </v-col>
          </v-row>

          <v-row>
            <v-col cols="3" class='subtitle-1 font-weight-black'>              
            </v-col>
            <v-col cols="3" class=''>
            </v-col>
          </v-row>

          <v-divider />
        </v-container>
      </v-card-text>
    </v-card>

    <v-container v-if="!isVisible">
      <v-row class="ma-0">
        <v-col cols="7" class="text-right">
          <span class="headline text-center">Paket Lelang Tahun Anggaran </span>
        </v-col>
        <v-col cols="2">
          <v-select
            :items="itemsTahunAnggaran"
            label="Tahun Anggaran"
            v-model="tahunAnggaranSel"
            single-line
            dense
            class="headline"
            @change="tahunAnggaranSelChange"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="mx-2">
        <v-col cols="2">
          <!-- ADD BUTTON -->
          <!-- <v-btn dark color="green" @click="openForm(null)">Tambah</v-btn>    -->
        </v-col>   
        <v-col cols="10">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-col>       
      </v-row>
      <v-row class="mx-2">
          <v-col cols="10">
          </v-col>
          <v-col cols="2">
              <v-btn color="cyan" dark @click="refreshPage()">Refresh</v-btn>
          </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12">
          <v-data-table
              class="elevation-1"
              :headers="table.headers"
              :items="table.items"
              :items-per-page="10"
              :single-select="true"
              :search="search"
              item-key="id"
              no-data-text="Belum ada data !"
          >

              <template v-slot:item.totalPagu="{item}">
                <div class="text-right">
                  {{ getNumberSep(item.totalPagu) }}
                </div>
              </template>

              <template v-slot:item.volumePekerjaan="{item}">
                  {{ item.volumePekerjaan }} Paket
              </template>

              <template v-slot:item.peserta="{item}">
                  {{ getStatusIkut(item.id) }} 
              </template>

              <template v-slot:item.jenisPengadaan="{item}">
                  {{ getJenisPengadaan(item.jenisPengadaan) }}
              </template>

              <template v-slot:item.metodePemilihan="{item}">
                  {{ getMetodePemilihan(item.metodePemilihan) }}
              </template>

              <template v-slot:item.periode="{item}">
                  {{ getDateFormattedDatefns(item.mulaiDaftar) }} - {{ getDateFormattedDatefns(item.selesaiDaftar) }}
              </template>

              <!-- <template v-slot:item.satuanKerja="{item}">
                  {{ getDivisi(item.satuanKerja) }}
              </template> -->

              <template v-slot:item.statusPelaksanaan="{item}">
                <v-chip :color="getColorStatus(item.statusPelaksanaan)">
                  {{ getStatusPelaksanaan(item.statusPelaksanaan) }}
                </v-chip>
              </template>
              <template v-slot:item.actions="{item}">
                <v-btn color="blue" small icon @click="openForm(item, false)"> <v-icon small class="mr-2">mdi-file-find</v-icon> </v-btn>
                <div v-if="new Date(getDateFormattedDatefns(serverTime)) > new Date(getDateFormattedDatefns(item.mulaiDaftar)) && new Date(getDateFormattedDatefns(serverTime)) <  new Date(getDateFormattedDatefns(item.selesaiDaftar))">
                  <v-btn v-if="(item.metodePemilihan === 'TEN' || item.metodePemilihan === 'SEL') && getStatusIkut(item.id) === ''" color="cyan" small @click="daftarLelang(item)">DAFTAR</v-btn>
                  <v-btn v-if="(item.metodePemilihan === 'PLA' || item.metodePemilihan === 'TLA') && getUndanganLelang(item.id) == 'Undangan'" color="cyan" small @click="daftarLelang(item)">DAFTAR</v-btn>
                  <!-- <v-btn color="cyan" small dark  @click="openForm(item, false)" v-if="item.statusPelaksanaan === 'N' && item.status === 'AM'">Publish</v-btn> -->
                </div>
              </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <!-- FORM -->
    <v-dialog v-model="form.isShowing" persistent max-width="100%">
      <v-container>
        <v-card min-height="700px">   
          <v-card-text>
            <ProsesLelangVendor />
          </v-card-text>
            <!-- ACTIONS -->
            <v-card-actions>
                <v-btn color="cyan" dark @click="closeForm">Tutup</v-btn>
                <!-- <v-btn color="green" dark @click="publishPaket" v-if="!form.isView">Publish</v-btn> -->
            </v-card-actions>        
        </v-card>
        </v-container>
    </v-dialog>

    <!-- Notification -->
    <v-snackbar
        v-model="notification.show"
        :color="notification.color"
        :top="true"
        :right="true"
        :timeout=3000
    >
        {{notification.text}}
    </v-snackbar>

  </div>
</template>

<script>
import { statusDoc } from './../../lib/viewLib'
const axios = require('axios').default;
// import TextFieldDatePicker from "@/components/TextFieldDatePicker.vue"
import { rules } from './../../lib/rules'
import { getValueItem, /* itemsDivisi, */ tahunAnggaran, } from './../../lib/viewLib'
import { 
  itemsMetodePemilihan, itemsJenisPengadaan, itemsKualifikasi, itemsMetodeEvaluasi, itemsJenisKontrak, listJadwalPengadaan ,
  getJadwalLelang,  
  } from './../../lib/viewTenderLib'
import { format, parseISO } from 'date-fns'
const apiUrl = process.env.VUE_APP_ROOT_API

import ProsesLelangVendor from './../../components/lelang/ProsesLelangVendor'
// import PreviewLelang from './../../components/lelang/PreviewLelang'
// import DownloadDokumenPL from './../../components/lelang/DownloadDokumenPL'
// import UploadDokumenPL from './../../components/lelang/UploadPenawaranPL'
export default {
  components: {
      // "component-text-date-picker": TextFieldDatePicker,
      // PreviewLelang, DownloadDokumenPL, UploadDokumenPL,
      ProsesLelangVendor,
  },
  data: function() {
    return {
      remarkPerusahaan: '',
      remarkIjin: '',
      remarkAkta: '',
      remarkPemilik: '',
      remarkPengurus: '',
      remarkPengalaman: '',
      remarkPajak: '',
      // -----------------

      tab: null,
      listJadwal: [],
      listIkutLelang: [],
      listUndanganLelang: [],

      // Table
      table:
      {
        headers: 
        [
          // { text: "Kode", value: "kode" },
          { text: "Nama Paket", value: "nama" },
          // { text: "Volume", value: "volumePekerjaan" },
          { text: "Pengadaan", value: "jenisPengadaan" },
          { text: "Pemilihan", value: "metodePemilihan" },
          { text: "HPS", value: "totalPagu", align: 'end'},
          { text: "Status", value: "statusPelaksanaan" },
          { text: "Periode Daftar", value: "periode" },
          { text: "Daftar", value: "peserta" },
          { text: "Actions", value: "actions", sortable: false }
        ],
        items: []
      },
      itemsTahunAnggaran: tahunAnggaran,
      tahunAnggaranSel: 2021,
      rules: { required: rules.required },
      search: '',

      listKualifikasi: itemsKualifikasi,

      form:
      {
        paket:
        {
          kode: "",
          kegiatanId: 0,
          ppk: "",
          id: null,
          nama: "",              
          tahunAnggaran: 0,
          isPDN: false,
          isUsahaKecil: false,
          satuanKerja: "",
          volumePekerjaan: 1,
          listLokasiKerja: [],
          listPendanaan: [],
          
          totalPagu: 0,
          totalPaguLama: 0,
          kbli: "",
          bobotTeknis: 0,
          bobotHarga: 0,
          deskripsi: '',

          jenisPengadaan: "",
          metodePemilihan: "",
          metodeEvaluasi: "",
          kualifikasi: "",
          jenisKontrak: "",

          pelaksanaanKontrakAwal: null, 
          pelaksanaanKontrakAkhir: null, 
          pelaksanaanPemilihanPenyediaAwal: null, 
          pelaksanaanPemilihanPenyediaAkhir: null,

          fileLain: null,
          fileLampiran: null,
          fileKAK: null,
        },
        programId: 0,
        // listKegiatanByProgram: [],
        isShowing: false,
        isEditing: false,
        isView: false,
        isDeleting: false,
        isValid: false
      },

      // Notification
      notification:
      {
        show: false,
        color: "",
        text: ""
      },

      allListMetodePemilihan: itemsMetodePemilihan,
      allMetodeEvaluasi: itemsMetodeEvaluasi,
      allJenisKontrak: itemsJenisKontrak,
      allJadwalPengadaan: listJadwalPengadaan,
      serverTime: null
    }
  },
  methods: {
    async getServerTime() {
      await axios.get(`${apiUrl}/api/time`)
      .then( (response) => {
        this.serverTime = response.data.time;
        console.log('this.serverTime')
        console.log(this.serverTime)
      })
      .catch( (error) => {
        console.error(error);
      });
    },
    daftarLelang(paket) {
      const data = {
        paketPenyediaId: paket.id,
        vendorId: this.venId
      };

      axios.post(`${apiUrl}/api/lelang/peserta/daftar`, data)
      .then( () => {
        //console.log("DaftarLelang-Response: ", response);
        this.notification = {
          show: true,
          color: "success",
          text: "Proses pendaftaran berhasil",
        }

        this.getDataIkutLelang();
      })
      .catch( (error) => {
        this.notification = {
          show: true,
          color: "error",
          text: `Error dalam pendaftaran. [${error.message}]`
        }
      });
    },

    getColor: status => statusDoc.find(el => el.status === status).color+' white--text subtitle-1',
    getCapDoc: status => statusDoc.find(el => el.status === status).caption,
    // ----------
    getData() {
      console.log('vendorId', this.venId);
      axios.get(`${apiUrl}/api/rup/paket/lelang-vendor/${this.venId}/tahun/${this.tahunAnggaranSel}`)
      .then( (response) => { 
        this.table.items = response.data; 
        // console.log("LIST PAKET: ", response.data); 
      })
      .catch( (error) => { console.error(error); });
    },
    getStatusIkut(paketPenyediaId) {
      const itemUndangan = this.listUndanganLelang.find(el => el.paketPenyediaId === paketPenyediaId) 
      const itemIkutLelang = this.listIkutLelang.find(el => el.paketPenyediaId === paketPenyediaId)

      const jadwalDaftar = this.table.items.find(el => el.id == paketPenyediaId)
      console.log('jadwalDaftar',jadwalDaftar);
      const nowDate = new Date(this.getDateFormattedDatefns(this.serverTime));
      const mulaiDaftar = new Date(this.getDateFormattedDatefns(jadwalDaftar.mulaiDaftar));
      const selesaiDaftar = new Date(this.getDateFormattedDatefns(jadwalDaftar.selesaiDaftar));
      if(!itemIkutLelang && !itemUndangan) {
        if(nowDate > mulaiDaftar && nowDate < selesaiDaftar) {
          return ""
        }else if(nowDate < selesaiDaftar) {
          return ""
        }else {
          return 'Tutup'
        }
      }else {
        if(itemIkutLelang) {
          return 'Terdaftar'
        }else if (itemUndangan) {
          if(nowDate > mulaiDaftar && nowDate < selesaiDaftar) {
            return 'Undangan'
          }else if(nowDate < selesaiDaftar) {
            return ""
          }else {
            return 'Undangan/Tutup'
          }
        }else {
          return ''
        }
      }
      
      
    },
    getDataIkutLelang() {
      axios.get(`${apiUrl}/api/rup/paket/peserta/${this.venId}/tahun/${this.tahunAnggaranSel}`)
      .then( (response) => { 
        this.listIkutLelang = response.data; 
        // console.log("LIST PAKET: ", response.data); 
      })
      .catch( (error) => { console.error(error); });
    },
    getDataUndanganLelang() {
      axios.get(`${apiUrl}/api/rup/paket/peserta/undangan/${this.venId}/tahun/${this.tahunAnggaranSel}`)
      .then( (response) => { 
        this.listUndanganLelang = response.data; 
        console.log("LIST undangan lelang: ", response.data); 
      })
      .catch( (error) => { console.error(error); });
    },
    getUndanganLelang(paketPenyediaId) {
      const itemUndangan = this.listUndanganLelang.find(el => el.paketPenyediaId === paketPenyediaId) 
      const itemIkutLelang = this.listIkutLelang.find(el => el.paketPenyediaId === paketPenyediaId)
      if(itemIkutLelang) {
        return 'Terdaftar'
      }else if (itemUndangan) {
        return 'Undangan'
      }else {
        return ''
      }
    },
    getDateFormattedDatefns: function(date) {
      console.log(`tgl yg masuk: ${date}`)
      return date ? format(parseISO(date), "dd MMM yyyy HH:mm") : ''
    },
    tahunAnggaranSelChange() {
      this.getData()
    },
    getJenisPengadaan(val) {
        return val ? getValueItem(this.listJenisPengadaan, val) : ''
    },
    getMetodePemilihan: function(val) {
      return val ? getValueItem(this.allListMetodePemilihan, val) : ''
    },
    getNumberSep: function(data) {
      return parseInt(data, 10).toLocaleString('de-DE')
    },
    getStatusPelaksanaan: function(data) {
      let caption =''
      switch (data) {
        case 'A':
          caption = 'Aktif'
          break
        case 'S':
          caption = 'Selesai'
          break
        case 'G':
          caption = 'Gagal'
          break
        case 'U':
          caption = 'Ulang'
          break
        case 'P':
          caption = 'Pending'
          break        
        default:
          caption = 'Baru'
      }
      return caption
    },
    getStatus: function(data) {
      let caption =''
      switch (data) {
        case 'AM':
          caption = 'Approve Manajer'
          break
        case 'AP':
          caption = 'Approve PPK'
          break
        case 'AU':
          caption = 'Approve ULP'
          break
        case 'AD':
          caption = 'Approve Direksi'
          break
        case 'RM':
          caption = 'Reject Manajer'
          break
        case 'RP':
          caption = 'Reject PPK'
          break
        case 'RU':
          caption = 'Reject ULP'
          break
        case 'RD':
          caption = 'Reject Direksi'
          break
        default:
          caption = 'Baru'
      }
      return caption
    },
    getColorStatus: function(data) {
      let caption =''
      switch (data) {
        case 'S': 
          caption = 'success'
          break
        case 'P': 
          caption = 'warning'
          break
        case 'G':
        case 'U':
          caption = 'error'
          break
        default:
          caption = 'info'
      }
      return caption
    },
    getCurrentDateTime() {
      axios.get(`${apiUrl}/api/rup/paket/server/dttm`)
      .then( (response) => { 
        console.log("Jam Server: ", response.data); 
        return response.data;         
      })
      .catch( (error) => { console.error(error); });
    },   
    resetForm() {
      this.listJadwal = []
      this.kodeRUP = "";
      this.totalPekerjaan = 0;  
      this.paguKegiatan = 0;
      this.paguTerpakai = 0;
      this.paguSisa = 0;
      this.kegiatanSelect = null;

      this.form.paket = {
        kode: "",
        kegiatanId: 0,
        ppk: "",
        id: null,
        nama: "",              
        tahunAnggaran: this.tahunAnggaranSel,
        isPDN: false,
        isUsahaKecil: false,
        satuanKerja: "",
        volumePekerjaan: 1,
        listLokasiKerja: [],
        listPendanaan: [],
        listJadwal: [],
        totalPagu: 0,
        totalPaguLama: 0,
        kbli: "",
        bobotTeknis: 0,
        bobotHarga: 0,
        noArsip: "",
        deskripsi: '',
        jenisPengadaan: "",
        metodePemilihan: "",
        metodeEvaluasi: "",
        kualifikasi: "",
        jenisKontrak: "",
        pelaksanaanKontrakAwal: null, 
        pelaksanaanKontrakAkhir: null, 
        pelaksanaanPemilihanPenyediaAwal: null, 
        pelaksanaanPemilihanPenyediaAkhir: null,
        fileLain: null,
        fileLampiran: null,
        fileKAK: null,
      };
      this.formListLokasiKerja = [{            
        lokasiProyekId: 0,
        detail: "",          
        nilaiPekerjaan: 0,          
        uraianPekerjaan: "", 
        spesifikasiPekerjaan: "", 
        lampiran: "",
        paketPenyediaId: 0,        
      }],
      this.formListPendanaan = [{ 
        sumberDana: "", 
        asalDana: "", 
        mak: "", 
        pagu: 0 
      }],
      this.formListJadwalPengadaan = [],

      this.form.programId = "";
      // this.form.listKegiatanByProgram = []; 
      this.listMetodePemilihan = [];

      console.log("RESET FORM");
      console.log(this.form.paket.pelaksanaanPemilihanPenyediaAkhir);
    },
    async openForm(paket, view) {
      this.tab = 0
      if (paket)          
      {
        this.form.paket = Object.assign({}, paket);
        this.listJadwal = await getJadwalLelang(paket.id)

        // assign store
        this.$store.dispatch('lelang/assignPaket', paket)
        this.$store.dispatch('lelang/assignJadwal', this.listJadwal)
        this.$store.dispatch('lelang/assignPeserta', this.getStatusIkut(paket.id) == 'Terdaftar')

        this.form.isEditing = true;
        this.form.isShowing = true; 
        this.form.isView = view;
          
      }
      else
      {
        this.resetForm();
        this.form.isShowing = true;
      }          
    },
    closeForm() {
        this.form.isShowing = false;
        this.form.isEditing = false;
        this.form.isDeleting = false;
        this.form.isView = false;
        this.tab = 0
        this.$router.push({ name: 'TemporaryPage', params: { link: '/vendor'} }); 
    },
    refreshPage() {
        this.$router.push({ name: 'TemporaryPage', params: { link: '/vendor'} }); 
    },
  },
  computed: {
    statusPerusahaan: function() {
      return this.$store.getters['reg/statusPerusahaan']
    },
    statusIjin: function() {
      return this.$store.getters['reg/statusIjin']
    },
    statusAkta: function() {
      return this.$store.getters['reg/statusAkta']
    },
    statusPemilik: function() {
      return this.$store.getters['reg/statusPemilik']
    },
    statusPengurus: function() {
      return this.$store.getters['reg/statusPengurus']
    },
    statusPengalaman: function() {
      return this.$store.getters['reg/statusPengalaman']
    },
    statusPajak: function() {
      return this.$store.getters['reg/statusPajak']
    },
    isVisible: function() {
      return this.$store.getters['ven/regVisible']
    },
    statusDataPerusahaan: function() {      
      return this.$store.getters['ven/venStatusCaption']
    },
    statusColor: function() {
      return this.$store.getters['ven/venStatusCol']
    },
    statusColorText: function() {
      return this.$store.getters['ven/venStatusColText']+ ' title font-weight-black'
    },
    venId: function() { 
      return this.$store.getters['ven/venId']
    }
  },
  created: async function() {
    this.getServerTime()
    await axios.get(`${apiUrl}/vendor/${this.venId}`)
    .then((response) => {
      this.$store.dispatch('reg/assignStatusDoc', {
        statusPerusahaan: response.data.data.statusPerusahaan,
        statusIjin: response.data.data.statusIjin,
        statusAkta: response.data.data.statusAkta,
        statusPemilik: response.data.data.statusPemilik,
        statusPengurus: response.data.data.statusPengurus,
        statusPengalaman: response.data.data.statusPengalaman,
        statusPajak: response.data.data.statusPajak
      })
      
      // console.log("Data: ", response.data.data);
      this.remarkPerusahaan = response.data.data.remarkPerusahaan;
      this.remarkIjin = response.data.data.remarkIjin;
      this.remarkAkta = response.data.data.remarkAkta;
      this.remarkPemilik = response.data.data.remarkPemilik;
      this.remarkPengurus = response.data.data.remarkPengurus;
      this.remarkPengalaman = response.data.data.remarkPengalaman;
      this.remarkPajak = response.data.data.remarkPajak;
      
    })
    this.$store.dispatch('displayPageTitle', 'Dashboard Rekanan')

    //---------------
    this.tahunAnggaranSel = this.$store.getters.tahunAnggaran
    await this.getData()
    this.listJenisPengadaan = itemsJenisPengadaan
    this.getDataIkutLelang()
    this.getDataUndanganLelang()

    
  }
}
</script>

<style scoped>
.container{
  max-width: 100vw;
  padding:0px;
}
</style>